import React from 'react';
import { DocumentGroup, Document, DocumentsResponce } from 'services/requests';
import { OuterLinkIcon_16 } from 'assets/icons';
import Paper from 'components/Paper';
import styles from './DocumentList.module.css';

type Props = {
  documentList?: DocumentsResponce;
};

export default function Documents({ documentList }: Props) {
  return (
    <Paper className={styles.documents}>
      {documentList?.groups.map((documentGroup: DocumentGroup) => (
        <div className={styles.documents__wrapper} key={documentGroup.id}>
          <h3 className={styles.documents__subtitle}>{documentGroup.name}</h3>
          {documentGroup.documents.map((document: Document) => (
            <a
              className={styles.documents__link}
              href={document.link}
              target={'_blank'}
              key={document.id}
            >
              {document.name}
              <OuterLinkIcon_16 className={styles.documents__link_icon} />
            </a>
          ))}
          <div className={styles.documents__divider} />
        </div>
      ))}
    </Paper>
  );
}
